<template>
    <div>
        <template v-for="(item, index) in columns">
            <vbt-table-column :key="item.label + (index + '')"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            >
                <tree-column v-if="item.children" :columns="item.children"></tree-column>
            </vbt-table-column>
        </template>
    </div>
</template>
<script>
import treeColumn from './treeColumn.vue';
import { vbtTableColumn } from 'vbt-table';
export default {
    name: 'treeColumn',
    components: { treeColumn, vbtTableColumn },
    props: {
        columns: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {};
    }
};
</script>
<style lang='less'>

</style>